
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rabattkoder",
      function () {
        return require("private-next-pages/rabattkoder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rabattkoder"])
      });
    }
  